(function ($, Drupal) {
  Drupal.behaviors.slickCarousel = {
    attach: function (context) {
      console.log(context);
      $(context).find('[data-drupal-slick]').not('.slick-initialized').each(function () {
        var $carousel = $(this);
        var $dotsContainer = $carousel.find('.carousel-controls');
        var $slides = $carousel.children();
        // direct children are slides.  If only one slide, don't initialize Slick
        if ($slides.length <= 1) {
          // Hide any controls (dots/arrows) if they exist
          $carousel.find('.slick-dots, .slick-arrow').hide();
          return;
        }
        if (typeof $(this).slick === 'function') {
          $(this).slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
          });
        } else {
          console.warn('Slick plugin not available — check library attachment.');
        }
      });
    }
  };
})(jQuery, Drupal);
